import $ from 'jquery'
import jcf from 'jcf'
import 'slick-carousel'
import {OVERLAY_CLASS} from "./components/slider/slideVideo/SliderVideo";

export const renderDestinationFilter = (
  destinationFilter,
) => {
  // const destinationCloseLink = $(destinationFilter).find('.cards-banner-widget__float-nav')
  // const destinationLink = $(destinationFilter).find('.destintation-filter-widget li span')
  // const menuMobile = $('.destintation__main-nav, .menu-btn')
  // const bodyAnimate = $('html, body')

  const destinationFilterItem = $(destinationFilter).find('.destintation-filter-widget__filter-item')
  const FilterSlider = $(destinationFilter).find('.destintation-filter-widget__filter-items')

  // destinationCloseLink.click(() => {
  //   menuMobile.toggleClass('active')
  //   document.body.classList.toggle('no-scroll')
  //   bodyAnimate.animate({
  //     scrollTop: destinationCloseLink.offset().top - 70,
  //   }, 30)
  // })
  //
  // destinationLink.click(function () {
  //   if (window.innerWidth < 768) {
  //     menuMobile.toggleClass('active')
  //     document.body.classList.toggle('no-scroll')
  //     $('.menu-txt').html($(this).text())
  //     bodyAnimate.animate({
  //       scrollTop: destinationCloseLink.offset().top - 70,
  //     }, 30)
  //   }
  // })

  destinationFilterItem.each(function () {
    const item = $(this)
    const filterName = item.find('.destintation-filter-widget__hd')
    const filterDrop = item.find('.destintation-filter-widget__block')
    const destinationLinkActive = filterDrop.find('li span')
    const customScroll = item.find('.customscroll')

    if (!filterDrop.length) {
      item.removeClass('hasdrop')
    }

    if (item.hasClass('hasdrop')) {
      filterName.on('click keypress', function (e) {
        if (
          e.type === "keydown" &&
          e.key !== "Enter" &&
          e.key !== " "
        ) {
          return;
        }

        if (item.hasClass('opened')) {
          item.removeClass('opened')
        } else {
          destinationFilterItem.removeClass('opened')
          item.addClass('opened')

          jcf.replace( customScroll, 'Scrollable', {})
        }
      })

      destinationLinkActive.on('click keypress', function (e) {
        if (
          e.type === "keydown" &&
          e.key !== "Enter" &&
          e.key !== " "
        ) {
          return;
        }

        $(destinationFilter).find('.destintation-filter-widget__block li span').removeClass('active')
        destinationFilterItem.removeClass('active')
        item.addClass('active')
        $(this).addClass('active')
      })
    }

    if (filterName.hasClass('all-destinations-js')) {
      $(this).on('click keypress', function (e) {
        if (
          e.type === "keydown" &&
          e.key !== "Enter" &&
          e.key !== " "
        ) {
          return;
        }
        destinationFilterItem.removeClass('active opened')
        $(destinationFilter).find('.destintation-filter-widget__block li span').removeClass('active')
        item.addClass('active')
      })
    }
  })

  $(document).on('click', (e) => {
    if (!$(e.target).closest(destinationFilterItem).length) {
      destinationFilterItem.removeClass('opened')
    }
    e.stopPropagation()
  })

  FilterSlider.slick({
    rows: 0,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: true,
    swipeToSlide: true,
    focusOnSelect: true,
    accessibility: false
  })
}
